import { Contact } from '@/types/contact'

export const contactData: Contact = {
  name: 'Josef Doskar',
  phone: '+420728396112',
  email: 'josef@doskar.me',
  linkedInUrl: 'linkedin.com/in/doskar/'
}
